import { memo, useCallback, useState } from "react";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { TireSetDocumentSearchFiltersProps } from "./types";
import { initialFleetVehicleDocumentSearchForm } from "services/api/fleet/vehicles/documents/consts";
import { FleetDocumentSearchFormValues } from "services/api/fleet/vehicles/documents/types";
import { useTranslate } from "helpers";

const TireSetDocumentSearchFilters: React.FC<TireSetDocumentSearchFiltersProps> = (props) => {
  const { onAddNew, onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetDocumentSearchFormValues>(
    initialFleetVehicleDocumentSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleDocumentSearchForm);
  }, []);

  return (
    <div className="flex justify-between items-center">
      <div className="flex">
        <div className="mr-3">
          <TextField
            type="text"
            name="search"
            value={formValues.search}
            onChange={handleSearchChange}
            placeholder={t("admin.search.placeholder")}
            startIcon="/media/icons/search.svg"
            cssClassName="bg-white"
          />
        </div>
        <div className="mr-3 flex items-center">
          <span
            onClick={handleResetFormClick}
            className="text-xs font-bold cursor-pointer text-gray-700"
          >
            {t("admin.reset")}
          </span>
        </div>
      </div>
      <div className="py-3 flex justify-end">
        <Button
          variant="primary"
          children="Dodaj dokument"
          startIcon="/media/icons/plus.svg"
          onClick={onAddNew}
        />
      </div>
    </div>
  );
};

export default memo(TireSetDocumentSearchFilters);
